export default __webpack_public_path__ + "static/blogBanner-4da9ce7bdbbeaba44ef18caa63995154.png";